import { render, staticRenderFns } from "./AgencyProfileVolunteersSection.vue?vue&type=template&id=f47abc12&scoped=true"
import script from "./AgencyProfileVolunteersSection.vue?vue&type=script&lang=js"
export * from "./AgencyProfileVolunteersSection.vue?vue&type=script&lang=js"
import style0 from "./AgencyProfileVolunteersSection.vue?vue&type=style&index=0&id=f47abc12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47abc12",
  null
  
)

export default component.exports